<template>
    <div class="row">

        <div v-if="documentIsActive">
            <span v-if="fileReady"
                  class="green">
                {{ $t('fileState.done') }}
            </span>

            <span v-if="newFile"
                  class="blue">
                {{ $t('fileState.new') }}
            </span>

            <span v-if="fileInProgress"
                  class="orange">
                {{ $t('fileState.inProgress') }}
            </span>

            <span v-if="dumentIsEmpty"
                  class="grey">
                {{ $t('fileState.isEmpty') }}
            </span>
        </div>
        <div v-else-if="documentIsInProofreading">
            <span class="proofreading">
                {{ $t('fileState.inProofreading') }}
            </span>
        </div>
        <div v-else-if="documentIsProofreadingComplete">
            <span class="green">
                {{ $t('fileState.proofreadingComplete') }}
            </span>
        </div>
        <div v-else>
            <span class="grey">
                {{ $t('fileState.readingIssue') }}
            </span>
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { DocumentRow } from '@/models/DocumentRow'
    import { DocumentStatus } from '@/models/DocumentStatus'

    export default defineComponent({
        props: {
            rowData: Object as PropType<DocumentRow>,
        },
        computed: {
            documentRow(): DocumentRow{
                return this.rowData as DocumentRow;
            },
            documentIsActive(): Boolean{
                return this.documentRow.status == DocumentStatus.Active;
            },
            documentIsInProofreading(): Boolean {
                return this.documentRow.status == DocumentStatus.InProofreading;
            },
            documentIsProofreadingComplete(): Boolean {
                return this.documentRow.status == DocumentStatus.ProofreadingComplete;
            },
            status(): DocumentStatus{
                return this.documentRow.status;
            },
            fileReady(): Boolean {
                return this.documentRow.totalSegments != 0 &&
                    this.documentRow.translatedSegments == this.documentRow.totalSegments;
            },
            newFile(): Boolean {
                return this.documentRow.totalSegments != 0 &&
                    this.documentRow.draftSegments == 0 &&
                    this.documentRow.translatedSegments == 0 &&
                    this.documentRow.preTranslatedSegments == 0
            },
            fileInProgress(): Boolean {
                return this.documentRow.draftSegments != 0 ||                    
                    this.documentRow.preTranslatedSegments != 0 ||
                    (this.documentRow.translatedSegments != 0 &&
                    this.documentRow.translatedSegments != this.documentRow.totalSegments)
            },
            dumentIsEmpty(): Boolean {
                return this.documentRow.totalSegments == 0;
            },
        },
    })
</script>

<style lang="scss" scoped>
    .row {
        .blue {
            color: #0d99ff;
        }

        .green {
            color: #14ae5c;
        }

        .orange {
            color: #ffa629;
        }

        .grey {
            color: #b0b0b0;
        }

        .proofreading {
            color: var(--proofreading);
        }
    }
</style>